﻿import Chart from 'chart.js/auto'

export function setupManufacturerInsightDataResults() {
    $(".manufacturer-insight-data-result").each((index, element) => {
        const canvas = $(element);
        const url = canvas.data("url");
        const options = {
            responsive: true,
            plugins:{
                legend: {
                    display: false
                },
            },
            tooltips : {
                mode : 'index'
            },
            scales: {
                yAxes: [{
                    ticks: {
                        suggestedMin: 0,
                    }
                }]
            }
        };
        $.get(url, function (data) {
            const config = {
                type: 'line',
                data,
                options
            };
            const myLine = new Chart(canvas.get(0).getContext("2d"), config);
        });
    });

}